<template>
<div>
<nav class="navbar navbar-expand-lg" :class="{ 'scrolled': isScrolled }">
    <div class="nav-container">
      <a class="navbar-brand" @click="jump('/')">
        <div class="brand-logo">
          <svg viewBox="0 0 48 48" class="brand-svg">
            <defs>
              <linearGradient id="logoGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#818cf8"/>
                <stop offset="100%" style="stop-color:#a78bfa"/>
              </linearGradient>
              <linearGradient id="logoGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#60a5fa"/>
                <stop offset="100%" style="stop-color:#818cf8"/>
              </linearGradient>
            </defs>
            <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#logoGradient1)"/>
            <path d="M16 16 L24 24 L16 32" stroke="white" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M24 16 L32 24 L24 32" stroke="rgba(255,255,255,0.5)" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="36" cy="12" r="4" fill="#fbbf24"/>
          </svg>
        </div>
        <span class="brand-text">DCTECH 编程课堂</span>
      </a>
      
      <button class="navbar-toggler" type="button" @click="toggleMenu" :class="{ 'active': menuOpen }">
        <span class="toggler-icon"></span>
      </button>
      
      <div class="collapse navbar-collapse" :class="{ 'show': menuOpen }" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" @click="jump('/')" :class="{ 'active': $route.path === '/' }">
              <span class="nav-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                  <polyline points="9 22 9 12 15 12 15 22"/>
                </svg>
              </span>
              <span class="nav-text">首页</span>
            </a>
          </li>

          <li class="nav-item dropdown" :class="{ 'show': dropdownOpen }">
            <a class="nav-link dropdown-toggle" @click="toggleDropdown" :class="{ 'active': isCourseActive }">
              <span class="nav-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                </svg>
              </span>
              <span class="nav-text">课程体系</span>
              <svg class="dropdown-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </a>
            <div class="dropdown-menu" :class="{ 'show': dropdownOpen }">
              <a class="dropdown-item" @click="jump('/entry')">
                <span class="dropdown-icon">🌟</span>
                <span>编程启蒙</span>
              </a>
              <a class="dropdown-item" @click="jump('/python')">
                <span class="dropdown-icon">🐍</span>
                <span>Python课程</span>
              </a>
              <a class="dropdown-item" @click="jump('/cpp')">
                <span class="dropdown-icon">⚡</span>
                <span>C++课程</span>
              </a>
              <a class="dropdown-item" @click="jump('/java')">
                <span class="dropdown-icon">☕</span>
                <span>Java课程</span>
              </a>
              <a class="dropdown-item" @click="jump('/algorithm')">
                <span class="dropdown-icon">🧮</span>
                <span>算法课程</span>
              </a>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link" @click="jump('/faq')" :class="{ 'active': $route.path === '/faq' }">
              <span class="nav-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </span>
              <span class="nav-text">常见问题</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="modal-overlay" v-if="showLogin" @click.self="showLogin = false">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">登录 DCTECH 少儿编程</h5>
        <button type="button" class="close-btn" @click="showLogin = false">
          <span>&times;</span>
        </button>
      </div>
      
      <div class="modal-body">
        <div class="form-group">
          <label>登录名</label>
          <input class="form-control" placeholder="请输入登录名" v-model="mobile"/>
        </div>
        <div class="form-group">
          <label>密码</label>
          <input class="form-control" placeholder="请输入密码" v-model="code" type="password"/>
        </div>
      </div>
      
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="showLogin = false">取消</button>
        <button type="button" class="btn btn-primary" @click="onLogin()">登录</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import bus from '../utils/bus';

export default{
  data(){
    return{
      mobile:"",
      code:"",
      loadingText:"发送验证码",
      menuOpen: false,
      showLogin: false,
      isScrolled: false,
      dropdownOpen: false
    }
  },
  mounted(){
    let userStorage = window.localStorage.getItem("user");
    if(userStorage != null && userStorage != ""){
      let userObj = JSON.parse(userStorage);
      this.$store.commit('updateUser',userObj);
    }
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    isCourseActive() {
      return ['/entry', '/python', '/cpp', '/java', '/algorithm'].includes(this.$route.path);
    }
  },
    methods:{
      handleScroll() {
        this.isScrolled = window.scrollY > 20;
      },
      toggleMenu() {
        this.menuOpen = !this.menuOpen;
      },
      toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
      },
      closeDropdown() {
        this.dropdownOpen = false;
      },
      toClass(){
        location.href= "/class?user="+this.$store.state.user.Mobile;
      },
      jump(url){
        this.dropdownOpen = false;
        this.menuOpen = false;
        location.href=url;
      },
      startClass(){
        location.href="/class?target=17391200805&mobile="+this.$store.state.user.mobile;
      },
      login(){
        this.mobile = "";
        this.code = "";
        this.showLogin = true;
      },
      onLogin(){
        let postInfo = {};
        postInfo.mobile = this.mobile;
        postInfo.captcha = this.code;

        this.$http.post('https://programapi.dctechonline.cn/api/ap/login',postInfo).then(res=>{
            var result = res.data;
            if(result!= null){
              this.$store.commit('updateUser',result);
              window.localStorage.setItem("user",JSON.stringify(result));
              this.showLogin = false;
              location.href="/";
            }
            else{
              alert('登录失败');
            }
          })
      },
      loginout(){
        this.$store.commit('updateUser',null);
        window.localStorage.setItem("user","");
        bus.$emit('logout');
      },
      sendCode(){
        if(this.mobile == ""){
          alert('请先输入手机号码');
        }
        else{
          const phoneRegex = /^1[3-9]\d{9}$/;
          const phoneNumber = this.mobile;
          if (!phoneRegex.test(phoneNumber)) {
            alert('手机号码格式错误');
            return;
          }

          if(this.loadingText != "发送验证码"){
            return;
          }

          var timer = 90;
          this.loadingText = timer +"秒后重发";
          var inter = setInterval(()=>{
            timer --;
            this.loadingText = timer +"秒后重发";
            

            if(timer == 0){
              this.loadingText = "发送验证码";
              clearInterval(inter);
            }
          },1000);
          
          this.$http.get('https://programapi.dctechonline.cn/api/program/code/'+this.mobile).then(res=>{
            
            
          })
        }
      }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
@import '../styles/mixins.scss';

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 0;
  height: 72px;
  display: flex;
  align-items: center;
  background: rgba(17, 24, 39, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  
  &.scrolled {
    height: 64px;
    background: rgba(17, 24, 39, 0.98);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
    border-bottom-color: rgba(255, 255, 255, 0.05);
  }

  .nav-container {
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .navbar-brand {
    display: flex;
    align-items: center;
    gap: 14px;
    cursor: pointer;
    transition: all $transition;
    
    .brand-logo {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .brand-svg {
        width: 100%;
        height: 100%;
        filter: drop-shadow(0 4px 12px rgba(129, 140, 248, 0.4));
        transition: transform 0.3s ease;
      }
    }
    
    .brand-text {
      font-size: 20px;
      font-weight: 700;
      letter-spacing: -0.3px;
      color: white;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }
    
    &:hover {
      .brand-svg {
        transform: scale(1.08);
      }
    }
  }

  .navbar-toggler {
    display: none;
    width: 40px;
    height: 40px;
    border: none;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    transition: all $transition;
    
    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }
    
    .toggler-icon {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 2px;
      background: white;
      border-radius: 2px;
      transition: all $transition;
      
      &::before,
      &::after {
        content: '';
        position: absolute;
        left: 0;
        width: 20px;
        height: 2px;
        background: white;
        border-radius: 2px;
        transition: all $transition;
      }
      
      &::before {
        top: -6px;
      }
      
      &::after {
        top: 6px;
      }
    }
    
    &.active .toggler-icon {
      background: transparent;
      
      &::before {
        top: 0;
        transform: rotate(45deg);
      }
      
      &::after {
        top: 0;
        transform: rotate(-45deg);
      }
    }
    
    @include responsive(md) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .navbar-collapse {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
    
    @include responsive(md) {
      position: absolute;
      top: 72px;
      left: 0;
      width: 100%;
      background: rgba(17, 24, 39, 0.98);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
      padding: 20px;
      display: none;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      margin-left: 0;
      
      &.show {
        display: block;
        animation: slideDown 0.3s ease;
      }
    }
  }

  .navbar-nav {
    display: flex;
    align-items: center;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
    
    @include responsive(md) {
      flex-direction: column;
      width: 100%;
      gap: 8px;
    }
  }

  .nav-item {
    @include responsive(md) {
      width: 100%;
    }
  }

  .nav-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.75);
    cursor: pointer;
    border-radius: 10px;
    transition: all $transition;
    position: relative;
    
    .nav-icon {
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      svg {
        width: 100%;
        height: 100%;
      }
    }
    
    .nav-text {
      position: relative;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 6px;
      left: 16px;
      right: 16px;
      height: 2px;
      background: linear-gradient(90deg, #818cf8 0%, #a78bfa 100%);
      transform: scaleX(0);
      transition: transform 0.3s ease;
      border-radius: 1px;
    }
    
    &:hover {
      color: white;
      background: rgba(255, 255, 255, 0.1);
      
      &::after {
        transform: scaleX(0.3);
      }
    }
    
    &.active {
      color: white;
      background: rgba(255, 255, 255, 0.12);
      font-weight: 600;
      
      &::after {
        transform: scaleX(0.5);
      }
    }
    
    &.nav-link-login {
      background: linear-gradient(135deg, #818cf8 0%, #a78bfa 100%);
      color: white;
      padding: 10px 20px;
      border-radius: 12px;
      box-shadow: 0 4px 15px rgba(129, 140, 248, 0.4);
      
      .nav-icon svg {
        stroke: white;
      }
      
      &::after {
        display: none;
      }
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(129, 140, 248, 0.5);
        background: linear-gradient(135deg, #818cf8 0%, #a78bfa 100%);
        color: white;
      }
    }
    
    &.nav-link-class {
      background: rgba(16, 185, 129, 0.2);
      color: #34d399;
      border: 1px solid rgba(16, 185, 129, 0.3);
      
      .nav-icon svg {
        stroke: #34d399;
      }
      
      &::after {
        display: none;
      }
      
      &:hover {
        background: #10b981;
        color: white;
        border-color: #10b981;
        
        .nav-icon svg {
          stroke: white;
        }
      }
    }
    
    @include responsive(md) {
      width: 100%;
      justify-content: flex-start;
      padding: 14px 16px;
      font-size: 15px;
      
      &::after {
        display: none;
      }
    }
  }

  .dropdown {
    position: relative;
    
    .dropdown-toggle {
      .dropdown-arrow {
        width: 14px;
        height: 14px;
        margin-left: 4px;
        transition: transform 0.3s ease;
      }
      
      &.active .dropdown-arrow {
        transform: rotate(180deg);
      }
    }
    
    .dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      min-width: 200px;
      background: rgba(17, 24, 39, 0.98);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
      padding: 8px;
      margin-top: 8px;
      opacity: 0;
      visibility: hidden;
      transform: translateY(-10px);
      transition: all 0.3s ease;
      z-index: 1001;
      
      &.show {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }
      
      @include responsive(md) {
        position: static;
        margin-top: 4px;
        box-shadow: none;
        border: none;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
      }
    }
    
    .dropdown-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px 16px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.75);
      cursor: pointer;
      border-radius: 8px;
      transition: all 0.2s ease;
      white-space: nowrap;
      
      .dropdown-icon {
        font-size: 18px;
      }
      
      &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
        padding-left: 20px;
      }
    }
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease;
}

.modal-content {
  background: white;
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 400px;
  margin: 20px;
  animation: scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px 20px;
  border-bottom: none;
  
  .modal-title {
    font-size: 20px;
    font-weight: 700;
    color: $text-primary;
    margin: 0;
    letter-spacing: -0.3px;
  }
  
  .close-btn {
    width: 36px;
    height: 36px;
    border: none;
    background: rgba(0, 0, 0, 0.04);
    font-size: 20px;
    color: $text-muted;
    cursor: pointer;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all $transition-fast;
    
    &:hover {
      background: rgba(0, 0, 0, 0.08);
      color: $text-primary;
      transform: rotate(90deg);
    }
  }
}

.modal-body {
  padding: 0 28px 24px;
  
  .form-group {
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    label {
      display: block;
      font-size: 13px;
      font-weight: 600;
      color: $text-secondary;
      margin-bottom: 8px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    
    .form-control {
      width: 100%;
      padding: 14px 16px;
      font-size: 15px;
      border: 2px solid $border-color;
      border-radius: 12px;
      transition: all $transition-fast;
      background: #fafafa;
      
      &:focus {
        outline: none;
        border-color: $primary-color;
        background: white;
        box-shadow: 0 0 0 4px rgba($primary-color, 0.08);
      }
      
      &::placeholder {
        color: $text-muted;
      }
    }
  }
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 28px 28px;
  background: transparent;
  
  .btn {
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 12px;
    cursor: pointer;
    transition: all $transition;
    border: none;
    
    &.btn-secondary {
      background: rgba(0, 0, 0, 0.04);
      color: $text-secondary;
      
      &:hover {
        background: rgba(0, 0, 0, 0.08);
      }
    }
    
    &.btn-primary {
      background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
      color: white;
      box-shadow: 0 4px 15px rgba(99, 102, 241, 0.3);
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
